import styled from 'styled-components';

export const TransactionsStyle = styled.div`
  .generated-list {
    padding: 12px;
  }

  .fkTuFL {
    max-height: 400px;
  }

  .download-action-buttons {
    margin-top: -2%
  }

  label {
    margin-left: 12px;
  }
`;
